import { FileProps } from '@/common/types/common'
import { apiService } from './apiService'
import { fileEndpoints } from '@/api/apiEndpoint'

export const fileService = {
  async irFileUpload(
    companyId: number,
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData()
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.irFileUpload(companyId),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
  async uploadFile(
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData() 
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.uploadFile(),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  },
  async uploadFileImage(
    data: File[]
  ): Promise<FileProps[] | null> {
    try {
      const formData = new FormData() 
      data.forEach(file => {
        formData.append('files', file)
      })
      const response = await apiService.post<FileProps[]>(
        fileEndpoints.uploadFileImage(),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      return response
    } catch (err: any) {
      console.error(err)
      return null
    }
  }
}
